export default __webpack_public_path__ + "static/media/ndvi.b82a901d.png";